<template>
    <modal
        :value="show"
        :headline="headline"
        hide-footer
        @input="$emit('input', $event)"
    >
        <collapsible headline="via E-Mail" :headline-level="3" class="mb-18">
            <template #headlineAction>
                <app-button
                    size="small"
                    class="action"
                    :is-loading="isLoadingMails"
                    @click.native="loadMails">Jetzt abholen</app-button>
            </template>
            <p>Schicke eine E-Mail an <a :href="`mailto:${emailAddress}`" class="text-primary u-bold">{{ emailAddress }}</a> um ein Dokument deinem Dashboard hinzuzufügen.</p>
            <p>Nutze den <strong>Betreff</strong> um einen Titel zu vergeben. Andernfalls wird ein zufälliger Name generiert.</p>
            <p class="mb-0">Füge <strong>Tags</strong> über den E-Mail-Body als kommaseparierte Liste hinzu. <small>Beispiel: tag1,tag2,tag3</small> .</p>
        </collapsible>

        <collapsible headline="via GDrive" :headline-level="3" class="mb-18">
            <template #headlineAction>
                <app-button
                    size="small"
                    class="action"
                    :is-loading="isLoadingGDrive"
                    @click.native="loadCloud">Jetzt abholen</app-button>
            </template>
            <p>Melde dich mit dem Account <strong class="text-primary">bonbon.nhb@gmail.com</strong> an und lege eine Datei im Verzeichnis "documents" ab.</p>
            <p class="mb-0">Du kannst auch mit deinem <strong>Canon Drucker</strong> Scans direkt in GDrive hochladen.</p>
        </collapsible>
    </modal>
</template>

<script>
import Modal from '@/components/ui/Modal.vue'
import Collapsible from '@/components/ui/Collapsible.vue'
import AppButton from '@/components/ui/Button.vue'

export default {
    name: 'SendDocumentModal',

    components: { AppButton, Collapsible, Modal },

    props: {
        value: { type: Boolean, required: true },
        headline: { type: String, required: true },
    },

    data () {
        return {
            show: this.value,
            isLoadingMails: false,
            isLoadingGDrive: false,
        }
    },

    computed: {
        emailAddress () {
            return process.env?.VUE_APP_EMAIL_ADDRESS || 'unbekannt'
        },
    },

    watch: {
        value (value) {
            this.show = value
        },
    },

    methods: {
        async loadMails () {
            this.isLoadingMails = true

            try {
                const response = await this.$http.get('/command/reload-mails')
                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.$emit('reload')
                this.$toast.open({ type: 'success', message: response.data.successHtml })
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoadingMails = false
            }
        },

        async loadCloud () {
            this.isLoadingGDrive = true

            try {
                const response = await this.$http.get('/command/reload-cloud')
                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.$emit('reload')
                this.$toast.open({ type: 'success', message: response.data?.successHtml })
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoadingGDrive = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .collapsible__headline {
    width: 60%;
}

.action {
    flex: 1;
}
</style>
